module.exports = __webpack_public_path__ + "static/media/Bonaventure.92d0df46.jpg";